namespace advisorop.components.advisor {

    export class AccountMappingListController {        
        public accounts;
        public dg: DevExpress.ui.dxDataGridOptions;

        
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "There are currently no accounts that need to be mapped",
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgAccountsXY"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountNumber', caption: 'Number', width: 120 },                    
                    { dataField: 'accountName', caption: 'Name' },
                    { dataField: 'accountType2', caption: 'Type', width: 150 },                    
                    { dataField: 'investorName', caption: 'Investor' },
                    { dataField: 'custodianName', caption: 'Custodian' },
                    { dataField: 'openDate', caption: 'Opened', headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, dataType: 'date', format: 'shortDate', width: 90 },
                    { dataField: 'closedDate', caption: 'Closed', dataType: 'date', format: 'shortDate', width: 90 },
                    { dataField: 'householdName', caption: 'Household', width: 150 },
                    { dataField: 'id', caption: 'Actions', cellTemplate: 'btnActions', width: 160 }
                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onInvestorChanged({ id: data.id });
                //    }
                //}
            };
        }
        
        $onInit(): void {            
        }
        
    }
    
    class AccountMappingList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accounts: "<"
            };
            this.controller = ["advisorService", AccountMappingListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/account-mapping-list.html';
        }
    }
    angular.module(Constants.APP).component("accountMappingList", new AccountMappingList());

}